/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RelationshipTypeKeyValueModel } from '../../models/relationship-type-key-value-model';

export interface MasterDataRelationshipTypeLookupByValueGet$Params {
  value?: string;
  maxResults?: number;
  languageRegion?: string;
}

export function masterDataRelationshipTypeLookupByValueGet(http: HttpClient, rootUrl: string, params?: MasterDataRelationshipTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataRelationshipTypeLookupByValueGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('maxResults', params.maxResults, {});
    rb.query('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>;
    })
  );
}

masterDataRelationshipTypeLookupByValueGet.PATH = '/MasterData/RelationshipTypeLookupByValue';
